(() => {
  const TYPE_MS = 75;
  const DELETE_MS = 45;
  const HOLD_MS = 1600;
  const GAP_MS = 280;
  const CURSOR = '|';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseTerms(value) {
    return String(value || '')
      .split('|')
      .map((term) => term.trim())
      .filter(Boolean);
  }

  function startTypewriter(input) {
    if (input.dataset.typewriterBound === 'true') return;
    input.dataset.typewriterBound = 'true';

    const prefix = input.dataset.typewriterPrefix || 'Search for ';
    const terms = parseTerms(input.dataset.typewriterTerms);
    if (!terms.length) return;

    if (reduceMotion) {
      input.placeholder = prefix + terms[0];
      return;
    }

    let termIndex = 0;
    let charIndex = 0;
    let deleting = false;
    let timer = 0;
    let blinkOn = true;

    const isPaused = () => document.activeElement === input || Boolean(input.value);

    const paint = (text, withCursor) => {
      input.placeholder = prefix + text + (withCursor ? CURSOR : '');
    };

    const schedule = (fn, delay) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(fn, delay);
    };

    const tick = () => {
      if (isPaused()) {
        paint(terms[termIndex], false);
        schedule(tick, 400);
        return;
      }

      const term = terms[termIndex];

      if (!deleting) {
        charIndex += 1;
        paint(term.slice(0, charIndex), true);

        if (charIndex >= term.length) {
          deleting = true;
          let blinkCount = 0;
          const hold = () => {
            if (isPaused()) {
              paint(term, false);
              deleting = true;
              schedule(tick, 400);
              return;
            }
            blinkOn = !blinkOn;
            paint(term, blinkOn);
            blinkCount += 1;
            if (blinkCount >= Math.ceil(HOLD_MS / 400)) {
              schedule(tick, DELETE_MS);
              return;
            }
            schedule(hold, 400);
          };
          schedule(hold, 400);
          return;
        }

        schedule(tick, TYPE_MS);
        return;
      }

      charIndex -= 1;
      paint(term.slice(0, Math.max(charIndex, 0)), true);

      if (charIndex <= 0) {
        deleting = false;
        termIndex = (termIndex + 1) % terms.length;
        schedule(tick, GAP_MS);
        return;
      }

      schedule(tick, DELETE_MS);
    };

    input.addEventListener('focus', () => paint(terms[termIndex], false));
    input.addEventListener('blur', () => {
      if (!input.value) schedule(tick, GAP_MS);
    });

    paint('', true);
    schedule(tick, TYPE_MS);
  }

  const init = () => {
    document.querySelectorAll('.js-search-typewriter').forEach(startTypewriter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
